import Button from 'react-bootstrap/Button'
import React, { useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDispatch } from 'react-redux';
import { deposit,withdraw,nameupdate,mobileupdate,reset } from './action';

const Form = () => {
    let dispatch=useDispatch()
    let [amount,amountSet]=useState("")
    let [name,setname]=useState("")
    let [mobile,setMobile]=useState("")

    let [transactionId,updateTransactionId]=useState(1);


  return (
    <div className='container'>
        <h1 className='text-primary'>FORM COMPONENT</h1>
     <div className='row'>
        <div className='col-6'>
            <input 
            className='form-control' 
            type="number" 
            placeholder='Enter amount'
            value={amount} 
            onChange={(e)=>{
                amountSet(e.target.value)}}
            />    
        </div> 
        <Button variant="primary" className='col-2'  onClick={()=>{
            // dispatch({type:"deposit",payload:amount});
            dispatch(deposit(amount));
            updateTransactionId(transactionId+1)
            dispatch({type:"addTransaction",
                payload:{
                id:transactionId,
                amount:amount,
                date:new Date(),
                type:"credit"
            }
        });
            amountSet("");

        }}>DEPOSIT</Button> 

<Button variant="danger" className='col-3' style={{marginLeft:"5px"}} onClick={()=>{
            dispatch(withdraw(amount));
            updateTransactionId(transactionId+1)
            dispatch({type:"addTransaction",
                payload:{
                id:transactionId,
                amount:amount,
                date:new Date(),
                type:"debit"
            }})
            amountSet("");
        }}>WITHDRAW</Button> 
    </div> 

<br />

     {/* ___________________________________________________ */}
     <div className='row'>
        <div className='col-6'>
            <input 
            className='form-control' 
            type="text" 
            placeholder='Enter Name'
            value={name} 
            onChange={(e)=>{
                setname(e.target.value)}}
            />    
        </div> 
        <Button variant="primary" className='col-5' onClick={()=>{
            // dispatch({type:"nameupdate",payload:name});
            dispatch(nameupdate(name))
            setname("");
        }}>USER NAME UPDATE</Button> 
    </div> <br />
    {/* _____________________________________ */}
    <div className='row'>
        <div className='col-6'>
            <input 
            className='form-control' 
            type="tel" 
            placeholder='Enter Mobile Number'
            value={mobile} 
            onChange={(e)=>{
                setMobile(e.target.value)}}
            />    
        </div> 
        <Button variant="primary" className='col-5' onClick={()=>{
            // dispatch({type:"mobileupdate",payload:mobile});
            dispatch(mobileupdate(mobile))
            setMobile("");
        }}>MOBILE NUMBER</Button>
    </div> <br />
<Button variant='danger' onClick={()=>{
    // dispatch({type:"reset"})
    dispatch(reset())
}}>RESET</Button>
    <br /><br />

    </div>
  )
}

export default Form